import { z } from 'zod';

export const TwoFactorAuthenticationStatisticsSchema = z.object({
    total: z.number(),
    activated: z.number(),
});

export type TwoFactorAuthenticationStatistics = z.infer<typeof TwoFactorAuthenticationStatisticsSchema>;

export const TwoFactorAuthenticationGenerateConfigurationSchema = z.object({
    qrCode: z.string(),
    secret: z.string(),
});

export type TwoFactorAuthenticationGenerateConfiguration = z.infer<
    typeof TwoFactorAuthenticationGenerateConfigurationSchema
>;

export const TwoFactorAuthenticationDailyActivationStatisticsSchema = z.array(
    z.object({
        date: z.string(),
        activated: z.number(),
        unactivated: z.number(),
    }),
);

export type TwoFactorAuthenticationDailyActivationStatistics = z.infer<
    typeof TwoFactorAuthenticationDailyActivationStatisticsSchema
>;
